import { render } from "./RateOfExchangePage.vue?vue&type=template&id=b84d4fca&scoped=true"
import script from "./RateOfExchangePage.vue?vue&type=script&lang=js"
export * from "./RateOfExchangePage.vue?vue&type=script&lang=js"

import "./RateOfExchangePage.vue?vue&type=style&index=0&id=b84d4fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84d4fca"]])

export default __exports__